/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of NotificationsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification,
  SuccessResponse_1OfSuccessResponse_1OfNotification,
  Notification,
  Notification2,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockNotifications = [
  {
    id: 1,
    title: 'Stock Count Reminder',
    message: 'Your weekly stock count is due tomorrow',
    storeNumber: 'STORE001',
    isRead: false,
    createdDate: '2025-12-12',
    type: 1,
  },
  {
    id: 2,
    title: 'Order Confirmed',
    message: 'Your order #1234 has been confirmed for delivery on Dec 15',
    storeNumber: 'STORE001',
    isRead: true,
    createdDate: '2025-12-11',
    type: 0,
  },
  {
    id: 3,
    title: 'New Invoice Available',
    message: 'Invoice INV-001 is ready for review',
    storeNumber: 'STORE001',
    isRead: false,
    createdDate: '2025-12-10',
    type: 0,
  },
];

/* ---- Mocked Client Implementation ---- */

import { INotificationsClient } from '../../interfaces';
export class NotificationsClientMocked implements INotificationsClient {
  constructor(baseUrl?: string) {}

  async getnotification(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
    await delay();
    const notifications = mockNotifications.filter((n) => n.storeNumber === storeNumber && !n.isRead);
    return successResponse(successResponse(notifications)) as SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification;
  }

  async notificationsGET(notificationId: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
    await delay();
    const notification = mockNotifications.find((n) => n.id === notificationId) || mockNotifications[0];
    return successResponse(successResponse(notification)) as SuccessResponse_1OfSuccessResponse_1OfNotification;
  }

  async notificationsDELETE(notificationId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockNotifications.findIndex((n) => n.id === notificationId);
    if (index > -1) {
      mockNotifications.splice(index, 1);
    }
  }

  async getallnotification(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification> {
    await delay();
    const notifications = mockNotifications.filter((n) => n.storeNumber === storeNumber);
    return successResponse(successResponse(notifications)) as SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfNotification;
  }

  async notificationsPOST(body?: Notification, cancelToken?: CancelToken): Promise<SuccessResponse_1OfSuccessResponse_1OfNotification> {
    await delay();
    const newNotification: any = {
      id: mockNotifications.length + 1,
      title: body?.title || 'New Notification',
      message: body?.message || '',
      storeNumber: body?.storeIds?.[0] || 'STORE001',
      isRead: false,
      createdDate: new Date().toISOString().split('T')[0],
      type: body?.notificationType || 0,
    };
    mockNotifications.push(newNotification);
    return successResponse(successResponse(newNotification)) as SuccessResponse_1OfSuccessResponse_1OfNotification;
  }

  async notificationsPUT(id: number, body?: Notification2, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const notification = mockNotifications.find((n) => n.id === id);
    if (notification && body) {
      notification.title = body.title || notification.title;
      notification.message = body.message || notification.message;
    }
  }

  // ====== Auto-generated stub methods ======




}
